import type { ShiftFormActor } from "../../../shared/shift-production-form/contracts";

export type AnalysisAccessState = "LOADING" | "SERVICE_UNAVAILABLE" | "PIN" | "WORKSPACE";

export function analysisAccessState(
  phase: "loading" | "error" | "ready",
  actor: ShiftFormActor | null,
): AnalysisAccessState {
  if (phase === "loading") return "LOADING";
  if (phase === "error") return "SERVICE_UNAVAILABLE";
  return actor?.analysisAccess ? "WORKSPACE" : "PIN";
}
